import { colors, COLORS } from '../../../../../constants/colors';

export const useStyles = () => {
  return {
    text: {
      color: colors.white,
      marginBottom: '20px',
    },
    button: {
      backgroundColor: COLORS.DARK_GREY,
      borderColor: colors.white,
      color: colors.white,
      width: 'fit-content',
      '&:hover': {
        borderColor: colors.white,
      },
    },
  };
};
